import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVercelComponent } from './simple-icons-vercel.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVercelComponent ],
    exports:      [ SimpleIconsVercelComponent ],
    bootstrap:    []
})
export class SimpleIconsVercelModule {}
